// extracted by mini-css-extract-plugin
export default {"debug":"styles_debug__2NMpX"};